import React, {useContext, useEffect} from 'react';
import {MainContext} from "contexts/main.context";
import SubHeader from "../helpers/subHeader/subHeader";
import Box from "@material-ui/core/Box";
import {Grid, Tooltip} from "@material-ui/core/index";
import {Divider, Switch, Typography} from "@material-ui/core";
import {MastersService} from "../../services";
import {useSnackbar} from "notistack";

export function Configuracion() {
	const [firstLoaded, setFirstLoaded] = React.useState(false);
	const [configuracion, setConfiguracion] = React.useState(null);

	const context = useContext(MainContext);
	const {enqueueSnackbar} = useSnackbar();
	const mastersService = new MastersService(context);

	useEffect(() => context.setHeaderTitle('Configuracion'), []);

	useEffect(() => {
		mastersService.getConfiguracion(
			response => setConfiguracion(response.data.result),
			error => enqueueSnackbar(error, {variant: 'error'})
		)
	}, []);

	const toggleCotizacionesEnabled = () => {
		setConfiguracion({...configuracion, cotizaciones: {...configuracion.cotizaciones, enabled: !configuracion.cotizaciones.enabled}});
	}

	const togglePedidosEnabled = () => {
		setConfiguracion({...configuracion, pedidos: {...configuracion.pedidos, enabled: !configuracion.pedidos.enabled}});
	}

	useEffect(() => {
		if (!configuracion || configuracion === {})
			return;

		if (!firstLoaded) {
			setFirstLoaded(true);
			return;
		}

		mastersService.editConfiguracion(
			configuracion,
			response => enqueueSnackbar("La configuración se editó correctamente.", {variant: 'success'}),
			error => enqueueSnackbar(error, {variant: 'error'})
		)
	}, [configuracion]);

	return (
		<>
			<SubHeader
				title={'Configuración'}
			/>
			<Box className='container-xl mt-3 mb-3'>
				{configuracion && (
					<Box className='wrapper'>
						<Grid className={"mb-2"}>
							<Box>
								<Typography variant={"body1"}>Cotizaciones</Typography>
							</Box>
							<Box>
								<Tooltip title={"Habilitar/deshabilitar carga de cotizaciones"} placement={"left"}>
									<div>
										<Typography variant={"body2"} component={"span"}>Habilitar carga</Typography>
										<Switch checked={configuracion.cotizaciones?.enabled || null} onChange={toggleCotizacionesEnabled}/>
									</div>
								</Tooltip>
							</Box>
						</Grid>
						<Divider/>
						<Grid className={"mt-3 mb-2"}>
							<Box>
								<Typography variant={"body1"}>Pedidos</Typography>
							</Box>
							<Box>
								<Tooltip title={"Habilitar/deshabilitar carga de pedidos"} placement={"left"}>
									<div>
										<Typography variant={"body2"} component={"span"}>Habilitar carga</Typography>
										<Switch checked={configuracion.pedidos?.enabled || null} onChange={togglePedidosEnabled}/>
									</div>
								</Tooltip>
							</Box>
						</Grid>
					</Box>
				)}
			</Box>
		</>
	)
}
